<header>
    <h1>Notes</h1>
</header>

<style>
    header {
        text-align: center;
        padding: 20px 0px;
        background-color: var(--primary-color);
        color: white;
    }
</style>
